var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLeftCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181,
    height: 709,
    viewBox: "0 0 181 709",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.977 492.426C151.125 456.691 166.817 419.691 168.327 382.344C168.442 379.422 168.499 376.499 168.499 373.581C168.499 305.361 139.076 259.701 84.4932 231.501C77.9979 62.2321 -7.5351 0 -151.346 0C-301.035 0 -457.125 97.6273 -457.125 283.002C-457.125 283.452 -457.117 283.902 -457.117 284.352C-493.396 314.144 -515.375 351.128 -515.375 395.073C-515.375 432.502 -504.545 471.085 -475.711 507.872C-515.452 536.432 -536.04 566.232 -537.82 596.352C-537.943 598.452 -538 600.551 -538 602.651C-538 697.192 -407.974 709 -209.617 709C-11.2555 709 180.324 681.75 180.324 587.208C180.324 555.616 164.619 522.873 120.977 492.426Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLeftCloud);
export default __webpack_public_path__ + "static/media/mobile-left-cloud.48a2b2a0a9e29fe14e87883337de4bbc.svg";
export { ForwardRef as ReactComponent };